<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Mentoring">
            <common-training-header/>
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px" v-if="! isAttendant">
            <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
            <a-col flex="0 1 300px" class="text-right">
                <a-button type="primary" icon="plus" @click="create">Tambah Mentoring</a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items.data" rowKey="hash" :loading="loading" :pagination="pagination" @change="tableChanged" bordered>
                    <a-table-column :width="100" key="attendant_photo" title="Photo" class="align-center text-small text-center">
                        <template slot-scope="record">
                            <div style="text-align: left; width: 70px; margin-right: 5px; display: inline-block">
                                <img :src="record.attendant.photo" v-if="record.attendant.photo != null" width="70px" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.attendant.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column :width="300" key="attendant" title="Peserta" className="align-center text-small">
                        <template slot-scope="record">'
                            <h3>
                                <a-icon type="user" /> {{ record.attendant.name }} <br>
                                <a-icon type="mail" /> {{ record.attendant.email }}
                            </h3>
                        </template>
                    </a-table-column>

                    <a-table-column :width="200" key="scheduled" title="Penjadwalan" className="align-center text-small">
                        <template slot-scope="record">
                            <div class="text-center">
                                <h3><a-icon type="calendar" /> {{ record.scheduled_at }}</h3>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column :width="150" key="aspect" title="Aspect" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <a-tag>{{ record.aspect.toUpperCase() }}</a-tag>
                        </template>
                    </a-table-column>

                    <a-table-column key="notes" title="Notes" className="align-center text-small">
                        <template slot-scope="record">
                            {{ record.notes | truncate(200, '...')  }}
                        </template>
                    </a-table-column>

                    <a-table-column :width="200" key="action" title="Action" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <a-button type="primary" @click="isAttendant ? view(record) : edit(record)"> View <a-icon type="right" /> </a-button>
                        </template>
                    </a-table-column>
                </a-table>
            </a-skeleton>
        </a-card>

        <a-drawer :width="720" placement="right" :closable="true" :visible="drawer.visible"  @close="() => drawer = { visible: false, mentoring: null, type: null }">
            <template v-if="drawer.type === 'creating' || drawer.type === 'editing'">

                <h2>Form Mentoring</h2>
                <a-divider />
                <a-form-model :form="form" :model="formData" labelAlign="left">
                    <a-descriptions bordered>
                        <a-descriptions-item label="Aspect" span="3">
                            <a-radio-group button-style="solid" v-model="formData.aspect">
                                <a-radio-button value="knowledge">Knowledge</a-radio-button>
                                <a-radio-button value="skill">Skill</a-radio-button>
                                <a-radio-button value="attitude">Attitude</a-radio-button>
                            </a-radio-group>
                        </a-descriptions-item>

                        <a-descriptions-item label="Peserta" span="3">
                            <a-select v-model="formData.attendant_id" show-search placeholder="Peserta" option-filter-prop="children" style="width: 300px" :filter-option="attendantFilterOption" @change="selectAttendant">
                                <a-select-option :value="o.id" v-for="o in attendants" :key="o.id">
                                    {{ o.name }}
                                </a-select-option>
                            </a-select>
                        </a-descriptions-item>

                        <a-descriptions-item label="Penjadwalan" span="3">
                            <a-date-picker v-model="formData.scheduled_at" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss')}"></a-date-picker>
                        </a-descriptions-item>

                        <a-descriptions-item label="Catatan" span="3">
                            <a-textarea v-model="formData.notes" placeholder="Catatan" :auto-size="{ minRows: 5}" />
                        </a-descriptions-item>

                        <a-descriptions-item label="Catatan Internal" span="3">
                            <a-textarea v-model="formData.internal_notes" placeholder="Catatan Internal (hanya bisa dilihat oleh admin)" :auto-size="{ minRows: 5}" />
                        </a-descriptions-item>

                        <a-descriptions-item label="Action" span="3">
                            <a-button size="small" @click="showConfirm" icon="interaction" type="primary" html-type="submit" :loading="processing" :disabled="processing">Save</a-button>
                        </a-descriptions-item>
                    </a-descriptions>
                </a-form-model>
            </template>

            <template v-else-if="drawer.type === 'view'">
                <h2>Summary Mentoring</h2>
                <a-divider />
                <a-descriptions bordered>
                    <a-descriptions-item label="Aspect" span="3">
                        <strong>{{ drawer.mentoring.aspect }}</strong>
                    </a-descriptions-item>

                    <a-descriptions-item label="Peserta" span="3">
                        <strong>{{ drawer.mentoring.attendant.name }}</strong>
                    </a-descriptions-item>

                    <a-descriptions-item label="Penjadwalan" span="3">
                        <strong>{{ drawer.mentoring.scheduled_at }}</strong>
                    </a-descriptions-item>

                    <a-descriptions-item label="Catatan" span="3">
                        <p>{{ drawer.mentoring.notes }}</p>
                    </a-descriptions-item>
                </a-descriptions>
            </template>
        </a-drawer>
    </div>
</template>

<script>
export default {
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        isAttendant() {
            return this.$laravel.roles[this.activeModule.module.identifier] === 'attendant'
        },
        pagination() {
            return { pageSize: this.pageSize, current: this.items.current_page, total: this.items.total, showSizeChanger: true }
        },
        pageSize() {
            return this.items.per_page
        }
    },
    created() {
        this.resetForm()
        this.getAttendants()
        this.items = this.getDefaultPagination()
        this.getItems()
    },
    data() {
        return {
            attendants: [],
            form: this.$form.createForm(this),
            loading: false,
            processing: false,
            drawer: {
                visible: false,
                mentoring: null,
                type: null
            },
            items: {},
            formData: {},
            filters: {
                q: '',
            }
        }
    },
    methods: {
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
        resetForm() {
            this.formData =  {
                scheduled_at: null,
                attendant_id: null,
                mentor_id: null,
                mentor: null,
                notes: null,
                internal_notes: null,
                aspect: null
            }
        },
        handleSubmit(e) {
            e.preventDefault()
            this.processing = true
            if (this.drawer.type === 'creating')
            {
                this.$http
                    .post(this.routeUri('api.classical.mentoring.store'), this.formData)
                    .then((r) => window.location.reload())
                    .catch((err) => this.handleXhrError(err))
            } else {
                this.$http
                    .put(this.routeUri('api.classical.mentoring.update', { mentoring_hash: this.drawer.mentoring.hash }), this.formData)
                    .then((r) => window.location.reload())
                    .catch((err) => this.handleXhrError(err))
            }
        },
        showConfirm(e) {
            this.$confirm({
                title: 'Konfirmasi',
                content: 'Anda yakin?',
                onOk: () => {
                    this.handleSubmit(e)
                },
                onCancel() {},
            })
        },
        attendantFilterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            )
        },
        selectAttendant(v) {
            this.formData.attendant_id = v
        },
        getAttendants() {
            this.$http
                .get(this.routeUri('api.general.attendants'))
                .then(r => (this.attendants = r.data))
        },
        isEditing() {
            return this.drawer.type === 'editing'
        },
        view(r) {
            this.drawer.type = 'view'
            this.drawer.visible = true
            this.drawer.mentoring = r
        },
        create() {
            this.drawer.type = 'creating'
            this.drawer.visible = true
        },
        edit(r) {
            this.formData = {
                training_id: r.training_id,
                scheduled_at: r.scheduled_at,
                attendant_id: r.attendant_id,
                mentor_id: r.mentor_id,
                notes: r.notes,
                internal_notes: r.internal_notes,
                aspect: r.aspect
            }

            this.drawer.type = 'editing'
            this.drawer.visible = true
            this.drawer.mentoring = r
        },
        getItems() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.classical.mentoring'), {
                    params: this.filters
                })
                .then( response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        }
    },
    filters: {
        truncate: function (text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
}
</script>
